var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-avatar ml-3"},[_c('img',{staticClass:"c-avatar-img ",attrs:{"src":_vm.user_image}})])}
var staticRenderFns = []

export { render, staticRenderFns }